// @flow
const prefix = str => `station/errors/${str}`;

export const GLOBAL_ERROR_THROW = prefix('GLOBAL_ERROR_THROW');
export const GLOBAL_ERROR_CAUGHT = prefix('GLOBAL_ERROR_CAUGHT');
export const GLOBAL_ERROR_ACKNOWLEDGED = prefix('GLOBAL_ERROR_ACKNOWLEDGED');


// WEBPACK FOOTER //
// ./src/app/modules/errors/action-types.js